import React, { Component, ErrorInfo, ReactNode } from 'react';
import { config } from '../../config/env';
import { reportCrash } from '../../services/Error/CrashReportingService';

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

interface ErrorBoundaryProps {
  children?: ReactNode;
  FallBackComponent?: ReactNode;
}

const isProduction = config.APP_ENV === 'production';
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
    error: undefined,
  };

  public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportCrash(error, {
      componentStack: errorInfo.componentStack,
    });
  }

  public render() {
    if (this.state.hasError) {
      return isProduction ? (
        <h1>Sorry, the system is temporarily unavailable. Please try again.</h1>
      ) : (
        <React.Fragment>
          <h1>{this.state.error?.message}</h1> <pre>{this.state.error?.stack}</pre>
        </React.Fragment>
      );
    }
    // Return children if there is no error
    return this.props.children;
  }
}

export default ErrorBoundary;
